import React from 'react';
import { Show, Tab, TabbedShowLayout, TextField } from 'react-admin';

export default ({ permissions, ...props }) => (
    <Show title='Owner' {...props}>
        <TabbedShowLayout>
            <Tab label="Summary">
                <TextField source="name" />
                <TextField source="email" />
                <TextField source="destination" />
            </Tab>
            <Tab label="SIPP">
                <TextField label="Destination" source="sipp.destination" />
            </Tab>
            <Tab label="Verification">
                <TextField label="ID" source="verification.id" />
            </Tab>
        </TabbedShowLayout>
    </Show>
);
